import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function PrivacyPolicyPage() {
  const lastUpdated = 'April 2, 2026';
  return <div className="bg-viridia-black min-h-screen pt-32 pb-24" data-id="element-2676" data-mp="2muk8smsmorg3">
      <SEOHead title="Privacy Policy | Viridia Analytics" description="Privacy Policy for Viridia Analytics. Learn how we collect, use, and protect your personal data." canonical="/privacy" data-id="element-2677" data-mp="2mw57molz6wjr" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2678" data-mp="2is7503xfz3ly">
        <ScrollReveal data-id="element-2679" data-mp="2its0bvrkyqkv">
          <div className="text-center mb-16" data-id="element-2680" data-mp="243kr86ngqjwu">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-2681" data-mp="244vtu3569lmd">
              Privacy Policy
            </h1>
            <p className="text-gray-400" data-id="element-2682" data-mp="292xf8uq2lx10">Last Updated: {lastUpdated}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-2683" data-mp="1v4z92clwl6wl">
          <div className="bg-viridia-surface border border-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none" data-id="element-2684" data-mp="1z4zo9zgttm4p">
            <div className="space-y-8 text-gray-300 leading-relaxed" data-id="element-2685" data-mp="29qbopeqbiab0">
              <section data-id="element-2686" data-mp="24t1t1hcc52eq">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2687" data-mp="24rqo3e75lom1">
                  1. Introduction
                </h2>
                <p data-id="element-2688" data-mp="2jp17ratya0su">
                  Viridia Analytics ("we," "our," or "us") respects your privacy
                  and is committed to protecting your personal data. This
                  Privacy Policy explains how we collect, use, disclose, and
                  safeguard your information when you visit our website or use
                  our marketing and automation services.
                </p>
              </section>

              <section data-id="element-2689" data-mp="1w08anb1ldmwn">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2690" data-mp="1vzygrcdfevlo">
                  2. Information We Collect
                </h2>
                <p className="mb-2" data-id="element-2691" data-mp="1892usvvniumc">
                  We may collect the following types of information:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2692" data-mp="139q768wyhjip">
                  <li data-id="element-2693" data-mp="1syx1nlz8e6jh">
                    <strong data-id="element-2694" data-mp="1szg9g9v63ejs">Personal Identification Information:</strong> Name,
                    email address, phone number (including for SMS
                    communications), and company details when you fill out a
                    contact form, book a consultation, or opt in to messaging.
                  </li>
                  <li data-id="element-2695" data-mp="1a0u6epg3bdd8">
                    <strong data-id="element-2696" data-mp="1a1cdkh4ajbzx">Business Information:</strong> Information about
                    your business, marketing goals, current advertising
                    platforms, and CRM systems.
                  </li>
                  <li data-id="element-2697" data-mp="1j0haxk448zai">
                    <strong data-id="element-2698" data-mp="1j07f3fwe3xww">Usage Data:</strong> Information about how you
                    interact with our website, including IP addresses, browser
                    types, pages visited, and time spent on pages.
                  </li>
                </ul>
              </section>

              <section data-id="element-2699" data-mp="2ze7dgmfl7fi1">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2700" data-mp="2zhv7rnsuw5xt">
                  3. How We Use Your Information
                </h2>
                <p className="mb-2" data-id="element-2701" data-mp="issmx5ge4kan">
                  We use the collected information for various purposes,
                  including:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2702" data-mp="e0ixdqj6tm8w">
                  <li data-id="element-2703" data-mp="92hiziwpib3r">To provide, operate, and maintain our services.</li>
                  <li data-id="element-2704" data-mp="52grawklk3er">
                    To communicate with you, including responding to inquiries
                    and providing customer support.
                  </li>
                  <li data-id="element-2705" data-mp="572nj517vrz">
                    To send administrative information, such as updates to our
                    terms or policies.
                  </li>
                  <li data-id="element-2706" data-mp="3mblv12qeggxf">
                    To analyze usage patterns and improve our website and
                    service offerings.
                  </li>
                  <li data-id="element-2707" data-mp="1ki65k961t841">
                    To manage and optimize advertising campaigns on your behalf.
                  </li>
                </ul>
              </section>

              <section data-id="element-2708" data-mp="1shj6whofvgbo">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2709" data-mp="1xj0525fjgook">
                  4. SMS/Text Messaging Privacy
                </h2>
                <p className="mb-2" data-id="element-2710" data-mp="1ikejkeiuxeta">
                  If you opt in to receive text messages from us, the following
                  applies:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2711" data-mp="19schkbt53qgw">
                  <li data-id="element-2712" data-mp="19qt3mruyhria">
                    We collect phone numbers when users submit contact forms,
                    book consultations, or opt in to receive text messages.
                  </li>
                  <li data-id="element-2713" data-mp="zslpegs1xnjz">
                    Phone numbers may be used to send appointment confirmations,
                    follow-up messages, service updates, and promotional offers
                    via SMS.
                  </li>
                  <li data-id="element-2714" data-mp="uw50vlgxx76d">
                    By providing your phone number and opting in, you consent to
                    receive automated text messages from Viridia Analytics.
                  </li>
                  <li data-id="element-2715" data-mp="78rlejdqijkg">
                    Message and data rates may apply. Message frequency varies.
                  </li>
                  <li data-id="element-2716" data-mp="l8spe7paq745">
                    You can opt out at any time by replying{' '}
                    <strong data-id="element-2717" data-mp="g7v77v4add2n">STOP</strong> to any message.
                  </li>
                  <li data-id="element-2718" data-mp="v5nkegmd1pdo">
                    Reply <strong data-id="element-2719" data-mp="v4vzq0uaxc26">HELP</strong> for assistance.
                  </li>
                  <li data-id="element-2720" data-mp="q7vt9otji7aj">
                    <strong data-id="element-2721" data-mp="q6awdsjr6c9i">
                      SMS consent and phone numbers are NOT shared with third
                      parties or affiliates for marketing purposes.
                    </strong>
                  </li>
                  <li data-id="element-2722" data-mp="zz072l7hbm3s">
                    We use third-party platforms (e.g.,
                    GoHighLevel/LeadConnector) solely to facilitate our own SMS
                    communications with you.
                  </li>
                </ul>
              </section>

              <section data-id="element-2723" data-mp="6lh41ydfr2p9">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2724" data-mp="6i2yyide0fe4">
                  5. Cookies and Tracking Technologies
                </h2>
                <p data-id="element-2725" data-mp="fkcanbke6et3">
                  We use cookies and similar tracking technologies to track
                  activity on our website and hold certain information. Cookies
                  are files with a small amount of data which may include an
                  anonymous unique identifier. You can instruct your browser to
                  refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section data-id="element-2726" data-mp="y995bgjpb9bu">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2727" data-mp="13a6h9be4b74w">
                  6. Third-Party Services
                </h2>
                <p data-id="element-2728" data-mp="303run7jcruxa">
                  In providing our services, we interact with third-party
                  platforms such as Google Ads, Meta (Facebook/Instagram), Yelp,
                  and various CRM providers. We may share necessary information
                  with these platforms solely for the purpose of executing the
                  marketing services you have contracted us to perform. We do
                  not sell your personal data to third parties.
                </p>
              </section>

              <section data-id="element-2729" data-mp="2iuz36auyk6ef">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2730" data-mp="2irjjeuqca96o">
                  7. Data Security
                </h2>
                <p data-id="element-2731" data-mp="3bibfztbbgzuj">
                  We implement appropriate technical and organizational security
                  measures designed to protect the security of any personal
                  information we process. However, please note that no
                  electronic transmission over the Internet or information
                  storage technology can be guaranteed to be 100% secure.
                </p>
              </section>

              <section data-id="element-2732" data-mp="1r0n7bwc3s8kg">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2733" data-mp="1r4b37250t72c">
                  8. Your Rights
                </h2>
                <p data-id="element-2734" data-mp="3v61gbcjwtuna">
                  Depending on your location, you may have certain rights
                  regarding your personal data, including the right to access,
                  correct, or delete the information we hold about you. To
                  exercise these rights, please contact us using the information
                  provided below.
                </p>
              </section>

              <section data-id="element-2735" data-mp="hqwuqlykr24h">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2736" data-mp="hq3jb7oo7og0">
                  9. Changes to This Privacy Policy
                </h2>
                <p data-id="element-2737" data-mp="3xno2t20gupn">
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page and updating the "Last Updated" date.
                </p>
              </section>

              <section data-id="element-2738" data-mp="11ggrgy1e0jw5">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2739" data-mp="1atxxev6wx2g4">
                  10. Contact Us
                </h2>
                <p className="mb-2" data-id="element-2740" data-mp="16svxsd932odm">
                  If you have any questions about this Privacy Policy, please
                  contact us:
                </p>
                <ul className="list-none space-y-1" data-id="element-2741" data-mp="1kllj0fgsfp9o">
                  <li data-id="element-2742" data-mp="1flpg6jjtu3vp">
                    <strong data-id="element-2743" data-mp="1flfz5lgrf725">Company:</strong> Viridia Analytics
                  </li>
                  <li data-id="element-2744" data-mp="rvv3c1zicfbg">
                    <strong data-id="element-2745" data-mp="rx65jxdb1f0g">Location:</strong> Phoenix, AZ
                  </li>
                  <li data-id="element-2746" data-mp="nv2rr235xyc0">
                    <strong data-id="element-2747" data-mp="nvl0gy70i50t">Email:</strong>{' '}
                    <a href="mailto:info@viridiaanalytics.com" className="text-viridia hover:underline" data-id="element-2748" data-mp="11tj87kqtv37c">
                      info@viridiaanalytics.com
                    </a>
                  </li>
                  <li data-id="element-2749" data-mp="289btijiuwmvr">
                    <strong data-id="element-2750" data-mp="289v0j56yxqv0">Phone:</strong>{' '}
                    <a href="tel:6233000708" className="text-viridia hover:underline" data-id="element-2751" data-mp="2893gmrmqhhkk">
                      (623) 300-0708
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>;
}